// easing functions http://goo.gl/5HLl8
const inOutQuintic = function(t, b, c, d) {
  var ts = (t/=d)*t,
  tc = ts*t;
  return b+c*(6*tc*ts + -15*ts*ts + 10*tc);
}

// requestAnimationFrame polyfill http://goo.gl/sx5sts
const requestFrame = (function(){
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (cb) { return window.setTimeout(cb, 1000/60) }
})();

// Universal scroll position getter
const getScrollTop = () => document.documentElement.scrollTop ||
  document.body.parentNode.scrollTop ||
  document.body.scrollTop

// Universal scroll position setter
const setScrollTop = amount => {
  document.documentElement.scrollTop = amount;
  document.body.parentNode.scrollTop = amount;
  document.body.scrollTop = amount;
}

const getElementTop = function (el) {
  let top = 0
  if (el.offsetParent) {
    do { top  += el.offsetTop } while (el = el.offsetParent)
  }
  return top
}

function scrollTo (y = 0, opts = {}) {

  opts = Object.assign({
    duration: 500,
    offset: 0,
    easing: inOutQuintic
  }, opts)

  const start = getScrollTop()
  const change = y + opts.offset - start
  const increment = 20

  let currentTime = 0
  let stop = false

  let promise = new Promise((res, rej) => {

    (function animateScroll () {

      if (stop) return res(true)

      currentTime += increment
      setScrollTop(opts.easing(currentTime, start, change, opts.duration))

      if (currentTime >= opts.duration) return res(false)

      requestFrame(animateScroll)

    })()

  })

  promise.stop = () => stop = true

  return promise

}

function scrollToEl (el, opts = {}) {

  if (!(el instanceof HTMLElement))
    return Promise.reject(new Error(`Argument "el" should be an instance of HTMLElement, received ${typeof el}`))

  return scrollTo(getElementTop(el), opts)

}

export { scrollTo, scrollToEl }



// WEBPACK FOOTER //
// ./src/scroll-to-el.js